import trackingEventDictionary from "@core/dictionary/tracking-event";
import { LOB_ENUM } from "@routes/intel/ProductOnboarding/utils";
import type { BookmarkType, Signal } from "./types";

export const PAGE_SIZE = 10;

export const IMP_EXP_PERSONAS: string[] = [LOB_ENUM.EXPORT, LOB_ENUM.IMPORT, LOB_ENUM.EXPORT_AND_IMPORT];

export const PERSONA_TABS: { key: BookmarkType; label: string; lobs: string[] }[] = [
  { key: "buyer", label: "Buyers", lobs: [LOB_ENUM.EXPORT, LOB_ENUM.EXPORT_AND_IMPORT] },
  { key: "supplier", label: "Suppliers", lobs: [LOB_ENUM.IMPORT, LOB_ENUM.EXPORT_AND_IMPORT] },
];

export const SIGNAL_TOOLTIP: Record<Signal, string> = {
  lookalike: "Similar to companies you’ve already bookmarked. Recommended based on matching trade patterns, products, or markets.",
  emerging: "New or growing companies in your tracked markets. Recommended based on recent trade activity and rising trends.",
};

export const WHY_BOOKMARK_TEXT = "These are dynamic recommendations and change with time. Bookmarking will keep you updated on latest activities done by these companies";

export const CRITERIA_TOOLTIP = "The products, countries, ports or trade value from your onboarding inputs that this company matched.";

export const EMPTY_STATE_TEXT = {
  hscode: "We’re refining your recommendations. Add a few HS Codes or update your interests to unlock smarter suggestions.",
  bd: "We’re refining your recommendations. Add a few countries or update your interests to unlock smarter suggestions.",
};

export const COMPANY_VIEW_EVENT: Record<BookmarkType | "bd", string> = {
  buyer: trackingEventDictionary.intelHubRecommendationsBuyerCompanyView,
  supplier: trackingEventDictionary.intelHubRecommendationsSupplierCompanyView,
  bd: trackingEventDictionary.intelHubRecommendationsCompaniesCompanyView,
};

export const BOOKMARK_EVENT: Record<BookmarkType | "bd", string> = {
  buyer: trackingEventDictionary.intelHubRecommendationsBuyerBookmark,
  supplier: trackingEventDictionary.intelHubRecommendationsSupplierBookmark,
  bd: trackingEventDictionary.intelHubRecommendationsCompaniesBookmark,
};

export const DISMISS_EVENT: Record<BookmarkType | "bd", string> = {
  buyer: trackingEventDictionary.intelHubRecommendationsBuyerDismiss,
  supplier: trackingEventDictionary.intelHubRecommendationsSupplierDismiss,
  bd: trackingEventDictionary.intelHubRecommendationsCompaniesDismiss,
};
